import React from 'react';
import { useGcsStore } from '../../../store/useGcsStore';
import { MissionFailureMode, type MissionId } from '../../../types/gcs/mission';

interface FlightProgressIndicatorProps {
  gcsId: string;
  missionId: MissionId;
}

export const FlightProgressIndicator: React.FC<FlightProgressIndicatorProps> = ({ gcsId, missionId }) => {
  const progress = useGcsStore((state) => {
    const gcsData = state.data.get(gcsId);
    if (!gcsData) return undefined;
    return gcsData.missionEtasMap.get(missionId)?.progress ?? 0;
  });

  const isInFailureMode = useGcsStore((state) => {
    const gcsData = state.data.get(gcsId);
    if (!gcsData) return undefined;
    return gcsData.missionDetailedStateMap.get(missionId)?.failureMode != MissionFailureMode.NOMINAL;
  });

  return (
    <div
      style={{
        width: '100%',
        height: '8px',
        backgroundColor: '#e5e7eb',
        borderRadius: '4px',
        overflow: 'hidden'
      }}
    >
      <div
        style={{
          width: `${(progress ?? 0) * 100}%`,
          height: '100%',
          backgroundColor: isInFailureMode ? '#C00F0C' : '#0D74CE',
          borderRadius: '4px',
          transition: 'width 0.3s ease'
        }}
      />
    </div>
  );
};
